/** Допустимые для использования флаги */
export const FLAGS_MAP = {
    602: 'cloud-duplicates',
    582: 'cloud-image-generation',
    608: 'cloud-user-has-binded-card',
} as const;
